(function($) {

    function sidebarOpen(){
        $('html').addClass('overflow_hidden');
        $(".nav").addClass("nav-bg");
        $(".nav__sidebar").addClass("nav__sidebar--opened");
        $(".nav__hamburger-icon").addClass("nav__hamburger-icon--opened");
        $(".nav__hamburger").addClass("nav__hamburger--opened");
        setTimeout(() => {
            $('body').addClass('nav-overlay')
        }, 1)
    }

    function sidebarClose(){
        $(".nav__sidebar").removeClass("nav__sidebar--opened");
        $('body').removeClass('nav-overlay');
        $(".nav").removeClass("nav-bg");
        $(".nav__hamburger-icon").removeClass("nav__hamburger-icon--opened");
        $(".nav__hamburger").removeClass("nav__hamburger--opened");
        $('html').removeClass('overflow_hidden');
    }


    // Close modal on body overlay click
    $(document).on("click", "body.nav-overlay .body-content", function (e) {
        sidebarClose()
    })

    // Close modal on Escape
    $(document).keyup(function (e) {
        if (e.key === "Escape") {
            sidebarClose()
        }
    });
    $(".nav__hamburger").on("click", function () {
        if($(this).hasClass('nav__hamburger--opened')){
            sidebarClose();
        } else {
            sidebarOpen();
        }
    })


})(jQuery);